module.exports = __webpack_public_path__ + "img/cc-mbs-reta-black.712cc3f0.png";